import { render, staticRenderFns } from "./relationPresTransferHome.vue?vue&type=template&id=07ec6df4&scoped=true&"
import script from "./relationPresTransferHome.vue?vue&type=script&lang=ts&"
export * from "./relationPresTransferHome.vue?vue&type=script&lang=ts&"
import style0 from "./relationPresTransferHome.vue?vue&type=style&index=0&id=07ec6df4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ec6df4",
  null
  
)

export default component.exports